import { useTranslation } from 'react-i18next';
import Panel from 'components/panels/Panel';
import useAuth from 'hooks/useAuth';
import { useAxiosQuery } from 'hooks/useAxiosQuery';
import { DEVICE_TYPES_CACHE_KEY } from 'services/queryKeys';
import { DeviceType } from 'types';
import { canUpdateWatcherType } from 'utils/authorization';
import WatcherTypeForm from './WatcherTypeForm';

export const WatcherTypeFormController = ({ watcherType, onSubmit, isLoading, fieldErrors }) => {
  const { t } = useTranslation();
  const { user } = useAuth();

  const { data: deviceTypes = [], isLoading: isDeviceTypesLoading } = useAxiosQuery<DeviceType[]>(
    DEVICE_TYPES_CACHE_KEY,
    `/device-types/`,
    { suspense: false }
  );

  return (
    <Panel title={watcherType?.externalIdentifier || t('entities:watcherType.details')} titleVariant="h3">
      <WatcherTypeForm
        watcherType={watcherType}
        onSubmit={onSubmit}
        showButtons={canUpdateWatcherType(user?.role)}
        deviceTypeOptions={deviceTypes}
        isEditable={canUpdateWatcherType(user?.role)}
        isLoading={isLoading || isDeviceTypesLoading}
        fieldErrors={fieldErrors}
      />
    </Panel>
  );
};
